<template>
    <ul class="form_list">
        <li class="title">
            {{ $t('reservation_settings.popup_staff_settings.label_staff_connection') }}
            <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
            <span class="tooltip_wrap">
                <span class="tooltip">담당자와 직원을 연결하여 근무표를 관리하면 더욱 간편하게 스케줄을 관리할 수 있습니다.</span>
            </span>
        </li>
        <li class="cont">
            <select class="input_s w_full" v-model="selectedEmployeeID">
                <option :value="undefined">{{ $t('reservation_settings.popup_staff_settings.label_none') }}</option>
                <option
                    v-for="(e, index) in employees" :key="index"
                    :value="e._id">
                    {{ e.title }}
                </option>
            </select>
        </li>
    </ul>
</template>


<script>
export default {
    props: {
        value: String,
        employees: Array
    },
    data() {
        return {
            selectedEmployeeID: undefined
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function (newValue) {
                this.selectedEmployeeID = newValue
            }
        },
        selectedEmployeeID: {
            handler: function (newValue, oldValue) {
                if (newValue != oldValue) {
                    this.updateValue('employeeID', newValue)
                }
            }
        }
    },
    methods: {
        updateValue(key, value) {
            let data = {
                key: key,
                value: value
            }
            this.$emit('updateValue', data)
        }
    }
}
</script>